import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.manufacturerModelState
    ? { ...initialState, ...state.manufacturerModelState }
    : initialState;

export const selectManufacturerModelManufacturerFilter = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.manufacturerFilter
);

export const selectManufacturerModelMasterModelFilter = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.masterModelFilter
);

export const selectManufacturerOptions = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.manufacturerOptions.map((options) => options.name)
);

export const selectMasterModelOptions = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.masterModelOptions.map((options) => options.name)
);


export const selectManufacturerModelLicensingWeightFilter = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.licensingWeightFilter.toString()
);

export const selectLicensingWeightOptions = createSelector(
  [selectDomain],
(manufacturerModelState) =>
   manufacturerModelState.WeightFilterOptions.map((weight) => weight.toString())
)





export const selectManufacturerModelsLoading = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.loading
);

export const selectManufacturerModelsList = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.list
);

export const selectManufacturerModelsMeta = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.meta
);

export const selectManufacturerModelsPage = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.page
);

export const selectManufacturerModelsPerPage = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.perPage
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.isAddModalOpen
);

export const selectManufacturerModelForm = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.form
);

export const selectSelectedId = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.selectedId 
);





export const selectManufacturerModelYearFilter = createSelector(
  [selectDomain],
  (manufacturerModelState) => manufacturerModelState.yearFilter as string
);

export const selectYearFilterOptions = createSelector(
  [selectDomain],
    (manufacturerModelState) => manufacturerModelState.yearFilterOptions.map((year) => year.toString())
)

export const selectIsModelListFiltered = createSelector(
  [selectDomain],
  (manufacturerModelState) =>
    manufacturerModelState.manufacturerFilter !== "ALL" ||
    manufacturerModelState.masterModelFilter !== "ALL" ||
    manufacturerModelState.yearFilter !== "ALL" ||
    manufacturerModelState.licensingWeightFilter !== "ALL"
);

export const selectyearFilteredData = createSelector(
  [selectDomain],
  (manufacturerModelState) => {
    const { list, yearFilter, licensingWeightFilter, manufacturerFilter, masterModelFilter } = manufacturerModelState;
    let filteredList = list;
    if (yearFilter !== "ALL") {
      filteredList = filteredList.filter((item) => item.year === yearFilter);
    }
    if (licensingWeightFilter !== "ALL") {
      filteredList = filteredList.filter((item) => item.licenseWeight === licensingWeightFilter);
    }
    if (manufacturerFilter !== "ALL") {
      filteredList = filteredList.filter((item) => item.manufacturerName === manufacturerFilter);
    }
    if (masterModelFilter !== "ALL") {
      filteredList = filteredList.filter((item) => item.modelDesc === masterModelFilter);
    }
    return filteredList;
  }
)


export const selectDropDownsOptions = createSelector(
  [selectDomain],
    (manufacturerModelState) => manufacturerModelState.modelFormDropDowns
)
  